function isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
}

(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();

	/* Document ready functions */
	$(document).ready(function (){

		// Apply style to a if touch device
    if (isTouchDevice()) {
        $('a').addClass('mobile');
        $('a').removeClass('desktop');
    }
    else {
      $('a').addClass('desktop');
      $('a').removeClass('mobile');
    }

    // Smooth scroll to anchor
    $(document).on('click', '.section a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    });


	});

	$(window).resize(function () {

		// Get Window Width and Height on resize
		windowWidth = $(window).outerWidth();
		windowHeight = $(window).height();


	});

})(jQuery);
